// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"su_a bho_a bho_r bho_j","Photos__img":"su_b bho_b"};